<template>
  <div id="app" :data-theme="theme">
    <router-view></router-view>
  </div>
</template>

<script>
import utils from './utils'

export default {
  name: 'app',
  data() {
    return {
      theme: 'default'
    }
  },

  created() {
    this.setLanguage();
    this.setTitle();
  },

  mounted() {
    this.setTheme();
  },

  methods: {

    //设置H5语言
    setLanguage() {
      const lang = this.$route.query.lang
      if (lang) {
          this.$i18n.locale = lang
      } else {
          this.$i18n.locale = utils.lang.getLocale()
      }
    },

    //设置H5标题
    setTitle() {
      const path = this.$route.path
      if (path.includes('survey')) {
          document.title = this.$t('survey.title')
      }
    },

    //设置主题，用于确定主题色
    setTheme() {
      if (this.$s.getVip()) {
          this.theme = 'vip'
      }
    }
  }
}
</script>

<style lang="stylus">
#app
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: rgb(255, 255, 255);
  min-height: 100vh
  width: 750px;
  font-size: 30px
  position relative
  color: #2c3e50

div
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

.page-container
  width 100%
  height 100%
  padding-bottom 230px
  overflow hidden

img
  content: normal !important

/*修改mint messagebox confirm button 颜色*/
.confirm-btn
  color $theme-color !important
</style>
